import { NextRouter } from 'next/router'
import { ParsedUrlQuery } from 'node:querystring'
import { useEffect, useState } from 'react'
import { preserveParams } from './useNavigator'

export function useFormattedQuery(router: NextRouter) {
  const [parsedUrlQuery, setParsedUrlQuery] = useState<ParsedUrlQuery>()

  const [previousRouterKeys, setPreviousRouterKeys] = useState<{
    [x: string]: any
  }>()
  const [routerKeys, setRouterKeys] = useState<{ [x: string]: any }>()

  useEffect(() => {
    if (!router.isReady) return
    const currentQueryParams: ParsedUrlQuery = router.query
    const filteredQueryParams: ParsedUrlQuery = Object.keys(
      currentQueryParams,
    ).reduce((acc, key) => {
      if ([...preserveParams].includes(key)) {
        acc[key] = currentQueryParams[key]
      }
      return acc
    }, {})

    if (
      previousRouterKeys &&
      Object.keys(previousRouterKeys).length > 0 &&
      Object.keys(filteredQueryParams).length == 0
    )
      return
    if (routerKeys || !previousRouterKeys) setPreviousRouterKeys(routerKeys)

    if (!previousRouterKeys || Object.keys(filteredQueryParams).length > 0) {
      setRouterKeys(filteredQueryParams)
    }
  }, [router, router.query, router.isReady])

  useEffect(() => {
    if (previousRouterKeys && !routerKeys) return

    setParsedUrlQuery({
      ...routerKeys,
    })
  }, [routerKeys, previousRouterKeys])

  return parsedUrlQuery
}
